import {ChangeEventHandler, OptionHTMLAttributes} from 'react';
import {FormikProps} from 'formik';
import {useIntl} from 'react-intl';
import {FileToUpload} from './api';
import AdminDocumentForm from './AdminDocumentForm';

interface AdminDocumentFormLogicProps {
    formik: FormikProps<FileToUpload>;
    resetCategoryKey: number;
    fileOnChangeHandler: ChangeEventHandler;
}

const AdminDocumentFormLogic = ({
    formik,
    fileOnChangeHandler,
    resetCategoryKey,
}: AdminDocumentFormLogicProps): JSX.Element => {
    const intl = useIntl();

    const categoriesSelectOptions: OptionHTMLAttributes<string>[] = [
        {label: intl.formatMessage({id: 'DOCUMENTS.CATEGORIES.COMMERCIAL'}), value: 'commercial'},
        {label: intl.formatMessage({id: 'DOCUMENTS.CATEGORIES.TECHNICAL'}), value: 'technique'},
        {
            label: intl.formatMessage({id: 'DOCUMENTS.CATEGORIES.ADMINISTRATIVE'}),
            value: 'administratif',
        },
        {label: intl.formatMessage({id: 'DOCUMENTS.CATEGORIES.FIBER'}), value: 'fibre'},
        {label: intl.formatMessage({id: 'DOCUMENTS.CATEGORIES.RAPPORT_ROC'}), value: 'rapportRoc'},
        {
            label: intl.formatMessage({id: 'DOCUMENTS.CATEGORIES.CUSTOMER_SERVICE'}),
            value: 'serviceClient',
        },
    ];

    const languesSelectOptions: OptionHTMLAttributes<string>[] = [
        {label: intl.formatMessage({id: 'DOCUMENTS.LANGUES.FR'}), value: 'fr'},
        {label: intl.formatMessage({id: 'DOCUMENTS.LANGUES.EN'}), value: 'en'},
        {label: intl.formatMessage({id: 'DOCUMENTS.LANGUES.DE'}), value: 'de'},
        {label: intl.formatMessage({id: 'DOCUMENTS.LANGUES.ES'}), value: 'es'},
        {label: intl.formatMessage({id: 'DOCUMENTS.LANGUES.IT'}), value: 'it'},
    ];

    return (
        <AdminDocumentForm
            selectTypeOptions={categoriesSelectOptions}
            selectLangueOptions={languesSelectOptions}
            config={formik}
            resetCategoryKey={resetCategoryKey}
            fileOnChangeHandler={fileOnChangeHandler}
        />
    );
};

export default AdminDocumentFormLogic;
